import graphql__dbb3a414ceb4a01d9e02 from "./__generated__/ExternalServiceLinksCustomerAccountQuery.graphql.ts";
import graphql__f4021eabd1f146c3f2e0 from "./__generated__/ExternalServiceLinksContactQuery.graphql.ts";import * as React from "react";
import {useState, useEffect} from "react";
import {fetchQuery, graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {ExternalServiceLinksCustomerAccountQuery} from "./__generated__/ExternalServiceLinksCustomerAccountQuery.graphql";
import {ExternalServiceLinksContactQuery} from "./__generated__/ExternalServiceLinksContactQuery.graphql";

type ExternalServiceLinksProps = {
    identifier: string;
    type: 'customerAccount' | 'contact';
}

type ExternalLink = {
    service: string;
    label: string;
    url: string;
    iconUrl: string | null;
};

const ExternalServiceLinks: React.FC<ExternalServiceLinksProps> = ({identifier, type}) => {
    const environment = useRelayEnvironment();
    const [links, setLinks] = useState<ExternalLink[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const fetchLinks = async () => {
            try {
                if (type === 'customerAccount') {
                    const data = await fetchQuery<ExternalServiceLinksCustomerAccountQuery>(
                        environment,
                        graphql__dbb3a414ceb4a01d9e02,
                        {customerAccountIdentifier: identifier}
                    ).toPromise();

                    if (!cancelled && data?.customerAccountExternalLinks) {
                        setLinks(data.customerAccountExternalLinks);
                    }
                } else {
                    const data = await fetchQuery<ExternalServiceLinksContactQuery>(
                        environment,
                        graphql__f4021eabd1f146c3f2e0,
                        {contactIdentifier: identifier}
                    ).toPromise();

                    if (!cancelled && data?.contactExternalLinks) {
                        setLinks(data.contactExternalLinks);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch external links:', error);
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchLinks();

        return () => {
            cancelled = true;
        };
    }, [environment, identifier, type]);

    if (loading || links.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center space-x-2">
            {links.map((link) => (
                <a
                    key={link.service}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`Open in ${link.label}`}
                    className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
                >
                    {link.iconUrl ? (
                        <img
                            src={link.iconUrl}
                            alt={link.label}
                            className="w-6 h-6"
                        />
                    ) : (
                        <span className="text-xs font-medium text-gray-600">{link.label.substring(0, 1)}</span>
                    )}
                </a>
            ))}
        </div>
    );
};

export default ExternalServiceLinks;
